import React from 'react';
import { Stack } from '@mui/material';
import ScheduledAutomationsSection from './ScheduledAutomationsSection';
import StatusTriggersSection from './StatusTriggersSection';

export default function FormAutomationsSection({
  formId,
  workspaceId,
  hasFormId,
  formFields = [],
  organisationId = '',
  onGoToFields,
}) {
  return (
    <Stack spacing={3}>
      <StatusTriggersSection
        formId={formId}
        workspaceId={workspaceId}
        hasFormId={hasFormId}
        formFields={formFields}
        onGoToFields={onGoToFields}
      />
      <ScheduledAutomationsSection
        formId={formId}
        workspaceId={workspaceId}
        hasFormId={hasFormId}
        organisationId={organisationId}
      />
    </Stack>
  );
}
